import React from "react";
import './Registration.css';
// import Carousel from "react-elastic-carousel";
// import Item from "./Item";
// import Card from 'react-bootstrap/Card';
// import ListGroupItem from 'react-bootstrap/ListGroupItem';
// import ListGroup  from 'react-bootstrap/ListGroup';

// const breakPoints = [
//   { width: 1, itemsToShow: 1 },
//   { width: 550, itemsToShow: 2 },
//   { width: 768, itemsToShow: 2 },
//   { width: 1200, itemsToShow: 3 },
// ];

function RegistrationLeftSidePage() {
    return (
        <>
        <div className="reglogo">
            <img className=" client_logo_login_logout" src={process.env.PUBLIC_URL + '/images/ogcrm.png'} alt="clientlogo" />
            <h2>Try OrgGen CRM Free</h2>
        </div>
        <div className="carousel-wrapperreg pt-5">
        {/* <Carousel breakPoints={breakPoints}>
          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/lfed.png'} />
              <Card.Body>
                <Card.Text>
                I am connected with OrgGen Technologies quite a long time. They run good CRM Software,They are really cost effective, with such a low cost a high business response. Look forward for more campaign from them. The team is quite energetic and helps way out of the box.
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Pritam Salvi</ListGroupItem>
                <ListGroupItem>(Sales Manager)</ListGroupItem>
                <ListGroupItem>Rusan Pharma</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>

          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/lfed.png'} />
              <Card.Body>
                <Card.Text>
                Honestly, i have tried to using couple of crm softwares out there, but after OrgGen CRM Software i have never looked back. If you overlooking your are losing out! OrgGen Sales and Service Software and ther team. have made manage Sales leads so much easier.
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Neeraj Vora</ListGroupItem>
                <ListGroupItem>(Founder &amp; CEO)</ListGroupItem>
                <ListGroupItem>Adhrit towers</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>

          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/lfed.png'} />
              <Card.Body>
                <Card.Text>
                Had a very nice business experience here. The team was constantly in touch with me and updated me about the development progress. The project was completed on time, Thanks OrgGen Technologies.
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Nusrat</ListGroupItem>
                <ListGroupItem>(Sales Manager)</ListGroupItem>
                <ListGroupItem>Vinstall</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>

          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/bh.png'} />
              <Card.Body>
                <Card.Text>
                One of the great things about OrgGen Technologies is that Customer Service Management is perfection with the Sales functionality, rather than using a separate CRM for sales and service system for support.
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Ajay Singh</ListGroupItem>
                <ListGroupItem>(Owner)</ListGroupItem>
                <ListGroupItem>BH Capital</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>
          
          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/brainwonderslogo.png'} />
              <Card.Body>
                <Card.Text>
                CRM Software along with Cloud storage implementation. Really amazing work With OrgGen Technologies, Great work guys, awesome works.
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Manish Naidu</ListGroupItem>
                <ListGroupItem>(Founder and MD)</ListGroupItem>
                <ListGroupItem>Brain Wondres</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>

          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/delta.png'} />
              <Card.Body>
                <Card.Text>
                R&D is well on the product before going any CRM Software company. Guy's i told you this is Best CRM software product company in Mumbai, I'm satisfied From their service Thanks OrgGen Team.
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Kishore Vyas</ListGroupItem>
                <ListGroupItem>(Owner)</ListGroupItem>
                <ListGroupItem>Deltayards</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>

          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/lfed.png'} />
              <Card.Body>
                <Card.Text>
                Very happy with the CRM And Development services provides of OrgGen Technologies. Highly recommeneded.
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Sachin konde</ListGroupItem>
                <ListGroupItem>(Owner)</ListGroupItem>
                <ListGroupItem>Ibex Sure Foot</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>

          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/lfed.png'} />
              <Card.Body>
                <Card.Text>
                Best Technical Support I have ever experienced. The OrgGen Technologies is value for money with top notch after sales support from Orggen.
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Sakeel Syed</ListGroupItem>
                <ListGroupItem>(Founder and CEO)</ListGroupItem>
                <ListGroupItem>Lifedeal</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>

          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/cropped-hkjl-2.jpg'} />
              <Card.Body>
                <Card.Text>
                Best Crm Devlopment Comapny In Mumbai with monthly amc service good support by OrgGen team, Nice team with good technical knowledge, Thanks OrgGen to running my business smoothly.
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Anita Raut</ListGroupItem>
                <ListGroupItem>(Sales Head)</ListGroupItem>
                <ListGroupItem>Mehta Advisory</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>

          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/lfed.png'} />
              <Card.Body>
                <Card.Text>
                Getting an online system which suits our business process and marketing strategy as well as the working environment with our team, is a successful attempt of digital transformation of our business by automating the sales Leads Manage process. OrgGen Technologies Is custom Sales CRM which is implemented for us with the customised integration of features as per our requirements has created a tremendous change and productivity of our team. Thanks team OrgGen!
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Priyank Mehta</ListGroupItem>
                <ListGroupItem>(Sales Manager)</ListGroupItem>
                <ListGroupItem>Mspace Realty</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>

          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/nxg.jpg'} />
              <Card.Body>
                <Card.Text>
                I got my android application done from primary key technologies and they have helped me in every possible way.. Yuvraj &amp; Paddy is a very helpful person.. Highly recommended To OrgGenTechnologies.
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Deepa</ListGroupItem>
                <ListGroupItem>(Sales Manager)</ListGroupItem>
                <ListGroupItem>Nexg</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>

          <Item>
            <Card className="cardreg">
              <Card.Img variant="top" src={process.env.PUBLIC_URL + '/images/rio-homes-logo.png'} />
              <Card.Body>
                <Card.Text>
                They are the emerging players in CRM Softwar And website Devlopment. Keep up the good work guys!!
                </Card.Text>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroupItem>Sneha</ListGroupItem>
                <ListGroupItem>(Sales Manager)</ListGroupItem>
                <ListGroupItem>Rio Group</ListGroupItem>
              </ListGroup>
            </Card>
          </Item>


        </Carousel> */}
      </div>
      </>
    );
  }
export default RegistrationLeftSidePage;
